var _g, _g2, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcontooltipIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14513_23136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14513_23136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.64044 15.3694C4.32044 17.0501 6.61244 18 9.00044 18C10.7764 18 12.5164 17.4763 14.0044 16.4777C15.4804 15.4912 16.6324 14.0907 17.3164 12.4465C18.0004 10.8024 18.1684 8.98782 17.8324 7.24628C17.4844 5.49256 16.6204 3.89716 15.3604 2.63058C14.1004 1.37618 12.5044 0.52368 10.7524 0.1705C9.01244 -0.170502 7.20044 0 5.55644 0.682001C3.91244 1.364 2.50844 2.52097 1.51244 3.99459C0.52844 5.48038 0.000440598 7.22192 0.000440598 9C0.000440598 11.387 0.948441 13.6766 2.64044 15.3694ZM10.1284 5.56563C10.1284 7.08796 7.88444 7.08796 7.88444 5.56563C7.88444 4.0433 10.1284 4.0433 10.1284 5.56563ZM7.88444 9.57239C7.88444 9.26793 7.99244 8.97564 8.20844 8.75643C8.42444 8.54939 8.70044 8.4276 9.00044 8.4276C9.30044 8.4276 9.58844 8.54939 9.80444 8.75643C10.0084 8.97564 10.1284 9.26793 10.1284 9.57239V12.4222C10.1284 12.7267 10.0084 13.0189 9.80444 13.226C9.58844 13.4452 9.30044 13.567 9.00044 13.567C8.70044 13.567 8.42444 13.4452 8.20844 13.226C7.99244 13.0189 7.88444 12.7267 7.88444 12.4222L7.88444 9.57239Z",
    fill: "#5849A6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14513_23136)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#5849A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14513_23136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcontooltipIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IcontooltipIcon.96bbda1a.svg";
export { ForwardRef as ReactComponent };